import { omit } from "lodash-es";
import { config } from "../../../config";
import { useSupabaseCallback } from "../../../server/supabase/hooks";
import { SupabaseChatMomentService } from "../server/supabase-chat-moment-service";
import type { ChatMoment } from "../types";

export function useChatMomentService(): (chat_moment: ChatMoment | null) => Promise<void> {
  return useSupabaseCallback(
    async ({ supabase }, chat_moment: ChatMoment | null): Promise<void> => {
      if (!chat_moment) {
        return;
      }
      const slackMomentService = new SupabaseChatMomentService(supabase);

      const { error, data } = await slackMomentService.upsert({
        ...omit(chat_moment, "used_merge_fields"),
        slack_alias_id:
          chat_moment.slack_alias_id === config.slack.defaultSlackAliasId
            ? null
            : chat_moment.slack_alias_id,
        design: chat_moment.design ? chat_moment.design : undefined,
      });

      if (error || !data) throw new Error(error?.message);
    },
    [],
  );
}
